// File: src/pages/DipChatPage.js
// -----------------------------------------------------------------------------
// Page de chat pour l'agent DIP (utilise ConversationsContext unifié)
// -----------------------------------------------------------------------------
import React, { useContext, useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import MessageFeed from '../components/MessageFeed';
import ChatInput from "../components/ChatInput";
import { ConversationsContext } from "../context/ConversationsContext";
import { AuthContext } from "../context/AuthContext";
import { HistoryContext } from "../context/HistoryContext";
import { agentConfig } from "../config/agentConfig";

export default function DifyChatPage() {
  const { botId } = useParams();
  const { convs, sendMessage, initSession, isWaitingForResponse } = useContext(ConversationsContext);
  const { user } = useContext(AuthContext);
  const { addAction } = useContext(HistoryContext);
  const [chatEnabled, setChatEnabled] = useState(true);
  const [focus, setFocus] = useState(0);
  const [isInitialized, setIsInitialized] = useState(false);
  const historyInitRef = useRef(false);

  // Récupérer la conversation botId
  const conv = convs[botId] || { messages: [], botInfos: null };
  const messages = conv.messages || [];
  const expert = agentConfig[botId].getBotInfos(user);

  // Initialiser la conversation botId si elle n'existe pas
  useEffect(() => {
    if (!user) return;

    if (!convs[botId]) {
      const values = { id: botId, name: botId.charAt(0).toUpperCase() + botId.slice(1), title: "Assistant d'orientation" };
      initSession(null, values);
    }

    setIsInitialized(true);
  }, [user, convs, initSession, botId]);

  // Ajouter l'action dans l'historique à chaque visite (une seule fois par montage)
  useEffect(() => {
    if (!user || historyInitRef.current) return;
    historyInitRef.current = true;

    const actionType = botId === 'dip' ? 'DIP_CONVERSATION' : 'SUP_CONVERSATION';
    addAction({ type: actionType, values: {} });
  }, [botId]);

  function handleSend(message) {
    setChatEnabled(false);
    setFocus(focus + 1);
    sendMessage(botId, user?.gender, message);
  }

  function shouldEnableChat() {
    setChatEnabled(true);
  }

  if (!isInitialized) {
    return (
      <div className="flex flex-1 flex-col h-dvh w-full items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-indigo-500"></div>
      </div>
    );
  }

  return (
    <div className="flex flex-1 flex-col h-dvh w-full items-center py-6 px-4 no-scrollbar">
      <MessageFeed
        key={`messageFeed${botId}`}
        expert={expert}
        messages={messages}
        isAwaitingResponse={isWaitingForResponse}
        chatId={botId}
        enableChat={shouldEnableChat}
        onSuggestionClick={handleSend}
      />
      <div className="w-full max-w-3xl px-4 sticky items-center">
        <ChatInput
          placeholder={`Pose une question à ${botId.toUpperCase()}`}
          onSend={handleSend}
          focus={focus}
          chatEnabled={chatEnabled && !isWaitingForResponse}
        />
      </div>
    </div>
  );
}
